module.exports = __webpack_public_path__ + "static/media/USD.c4c2cdd7.svg";